import { useNavigate } from "react-router-dom";
import { getAuth, onAuthStateChanged } from "firebase/auth";
import { User as FirebaseUser } from "firebase/auth";
import { store } from "@/store";
import { clearAuth } from "@/store/slices/authSlice";
import { resetSession } from "@/store/slices/gameSessionSlice";

export const logoutUser = async (firebaseUser: FirebaseUser, navigate: ReturnType<typeof useNavigate>): Promise<{ success: boolean; error?: string }> => {
  try {
    const idToken = await firebaseUser.getIdToken();

    const backendResponse = await fetch(`${process.env.REACT_APP_API_BASE_URL}/logout`, {
      method: "POST",
      credentials: "include",
      headers: {
        "Authorization": `Bearer ${idToken}`,
      },
    });

    if (!backendResponse.ok) {
      const text = await backendResponse.text();
      console.error("Backend logout failed:", text);
      return { success: false, error: `Backend logout failed: ${text || backendResponse.statusText}` };
    }

    // Clear Redux state immediately to prevent stale data
    store.dispatch(clearAuth());
    store.dispatch(resetSession());

    const auth = getAuth();

    // Wait for auth state to actually clear before navigating
    await new Promise<void>((resolve) => {
      const unsubscribe = onAuthStateChanged(auth, (user) => {
        if (!user) {
          unsubscribe();
          resolve();
        }
      });
      auth.signOut();
    });

    navigate("/");
    return { success: true };
  } catch (err: unknown) {
    let errorMessage: string;
    if (err instanceof Error) {
      errorMessage = err.message;
    } else {
      errorMessage = "An unknown network error occurred during logout.";
    }
    console.error("Error during logout process:", err);
    return { success: false, error: errorMessage };
  }
};